
<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">如何使用公众号渠道二维码?</div>
      <div class="panel-body">
        <span class="span1">客户问题：我们公司主要是卖油漆，下面有很多的销售，我们公司想接入一个系统，吸粉，然后帮我们品牌多宣传，提高销售转化率。那我们该如何解决呢？</span>
        <p class="p1">解决方法</p>
        <p class="span1">
          1、将企业公众号接入汇客软件，利用渠道二维码功能，给每位销售生成一个带参数的渠道二维码，该二维码可以统计得到是哪位销售带来的客户;(亦可在手机端自动生成专属电子名片)，并且可以指定由谁接待，如果该销售既是销售又是接待客服，则可由自己接待。
          <br />2、利用吸粉数量/成单业绩作为月度综合考核绩效，如:
          <br />①带来一个粉丝奖励x元;(以吸粉数量作为考核——提高业务员工作积极性)
          <br />②如果当月或者之后有成交，则额外奖励成单奖(以成交业绩作为额外激励)，相信配合这个激励政策，你公司的销售一定会更用心去销你公司的产品
          <br>3、即使员工离职，只要客户不取关，还是在公众号里，通过汇客软件，就可以激活客户!(保护客户资源不流失)
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


